import ESuranceMembershipBusinessModelBase from '../_generated/modelBases/e-surance-membership-business-model-base';

export default class ESuranceMembershipBusinessModel extends ESuranceMembershipBusinessModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
